import React, {Component} from "react";

const withViewPortContext = (OriginalComponent) =>
  class ViewPortContext extends Component {
    state = {
      isItInViewport: false
    };
    element = React.createRef();
    componentDidMount() {
      this.checkViewPort();
      document.addEventListener(`scroll`, this.checkViewPort);
    }
    componentWillUnmount() {
      document.removeEventListener(`scroll`, this.checkViewPort);
    }
    checkViewPort = () => {
      const heightViewport = window.innerHeight;
      const heightOfEl = this.element.current.offsetHeight;
      const topPositionOfEl = this.element.current.getBoundingClientRect().top;
      if (
        heightViewport < topPositionOfEl ||
        topPositionOfEl + heightOfEl < 0
      ) {
        this.setState({
          isItInViewport: false
        });
      } else {
        this.setState({
          isItInViewport: true
        });
      }
    };
    render() {
      return (
        <div ref={this.element}>
          <OriginalComponent {...this.props} {...this.state} />
        </div>
      );
    }
  };

export default withViewPortContext;
